import { AfterViewInit, Component, Input, OnInit, OnDestroy } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { FileUploader } from 'ng2-file-upload';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { AccountService, EventManager } from 'src/app/core';
import { Constant } from 'src/app/core/constant';
import { UploaderService } from 'src/app/shared/services/uploader.service';
import { environment } from 'src/environments/environment';
declare var $;
@Component({
  selector: 'add-add-link-popup',
  templateUrl: './add-link-popup.component.html',
  styleUrls: ['./add-link-popup.component.scss']
})
export class AddLinkPopUpComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() id: string;
  @Input() isShow: boolean = false;
  editForm = this.fb.group({
    title: [''],
    link: ['', [Validators.required]],
    image: [''],
  });
  isSaved: boolean = false;
  uploader: FileUploader;
  subscriptions?: Subscription[] = [];
  constructor(
    // private modalRef : NzModalRef,
    public fb: FormBuilder,
    public formBuilder: FormBuilder,
    public uploaderService: UploaderService,
    public eventManager: EventManager
  ) {

  }
  ngOnInit() {
    this.subscriptions = [
      this.eventManager.subscribe('open-link', (res) => {
        this.isShow = true;
        this.editForm.patchValue({
          title: '',
          link: '',
          image: '',
        });
        this.isSaved = false;
      }),
      this.eventManager.subscribe('close-link', (res) => {
        this.close();
      }),
      this.eventManager.subscribe('add-link-image-upload', (res) => {
        this.editForm.patchValue({
          image: res.content.imagePath
        });
      }),
    ]
    
    this.uploader = this.uploaderService.initUploader(
      environment.urlUploadBackEnd + Constant.API_UPLOAD, 'add-link-image-upload', 'image', {scaleMax: 1000});
  }
  ngAfterViewInit(): void {
  }
  ngOnDestroy(): void {
    this.eventManager.destroys(this.subscriptions);
  }
  close() {
    this.isShow = false;
  }
  save() {
    this.isSaved = true;
    if (this.editForm.invalid) {
      return;
    }
    const title = this.editForm.value.title ? `<span>${this.editForm.value.title || 'Link'}</span>` : '';
    const image = this.editForm.value.image ? `<image>${this.editForm.value.image}</image>` : '';
    this.eventManager.broadcast({
      name: 'add-content-custom-editor',
      content: {
        value: `<link>${title}${image}${this.editForm.value.link}</link>`
      }
    });
    this.isSaved = false;
    this.editForm.patchValue({
      link: ''
    });
    this.close();
  }
  viewImage(name, url) {
    this.eventManager.broadcast({
      name: 'show-image',
      content: {
        image: {
          fileName: name,
          url
        }
      }
    });
  }
}
